import { SelectOption } from '@frontend/components/basic-forms';
import { ALL_ICONS } from '@frontend/icons';
import React, { useMemo } from 'react';

import type { IconType } from '@frontend/icons';

interface UseFunctionalityIconSelectProps {
    iconType: IconType;
    subset?: string[];
}

interface ViewProps {
    options: SelectOption<string>[];
}

const useFunctionalityIconSelect = (props: UseFunctionalityIconSelectProps): ViewProps => {
    const options = useMemo<SelectOption<string>[]>(() => {
        const icons = ALL_ICONS.filter((target) => target.type === props.iconType);
        return icons.map((target) => {
            const Icon = target.display;
            return {
                label: target.label,
                value: target.value,
                display: (
                    <span className='flex items-center gap-2'>
                        <Icon className='h-6 w-6' /> <span>{target.label}</span>
                    </span>
                )
            };
        });
    }, [props.iconType, props.subset]);

    return { options };
};

export default useFunctionalityIconSelect;
